import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import App from './App.vue';
import { routes } from './router/index';
import { store } from './store/index';

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
// import "firebase/analytics";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCuRKSM3NRMEt3Ms1F4y_Q73YvTZOdDcIQ",
  authDomain: "bible-esv-140cb.firebaseapp.com",
  databaseURL: "https://bible-esv-140cb.firebaseio.com",
  projectId: "bible-esv-140cb",
  storageBucket: "bible-esv-140cb.appspot.com",
  messagingSenderId: "1068741506999",
  appId: "1:1068741506999:web:5b0bd3d62e5115951c9a32",
  measurementId: "G-HG204W5MNR"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

// make auth and firestore references
const auth = firebase.auth();
const db = firebase.firestore();

// // Allow const ref to be used anywhere in project
window.auth = auth;
window.db = db;

Vue.use(VueRouter);
Vue.use(VueResource);

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js